import IsAllowed from './IsAllowed';

export default IsAllowed;
